import { render, staticRenderFns } from "./DriversMap.vue?vue&type=template&id=228f2c48&"
import script from "./DriversMap.vue?vue&type=script&lang=js&"
export * from "./DriversMap.vue?vue&type=script&lang=js&"
import style0 from "./DriversMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports